<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain
      class="padding-b pb-md-12"
      maxwidth-container="610px"
    >
      <Loading v-if="loading" />
      <ErrorServidor v-else-if="erro" />
      <template v-else>
        <TituloPagina :titulo="tituloPagina" class="mt-5 mt-md-11" />

        <template v-if="!loading">
          <div class="mt-7 body-2">
            <p class="mb-0 primary--text">
              E-mail
            </p>
            <p class="mb-0 grey--text text--darken-2">
              <strong>{{ dadosPessoais.email }}</strong>
            </p>
          </div>

          <v-form class="mt-8">
            <p class="body-2 primary--text">
              Meus dados pessoais
            </p>

            <v-text-field
              v-model.trim="dadosPessoais.name"
              background-color="white"
              label="*Nome completo"
              filled
              :disabled="isNotConsumidor"
              data-cy="input_nome_completo"
              :error-messages="errorMessagesNome"
              @blur="$v.dadosPessoais.name.$touch()"
            />

            <v-text-field
              v-model="dataLayout"
              v-mask="'##/##/####'"
              label="Data de nascimento"
              background-color="white"
              filled
              maxlength="10"
              :disabled="isNotConsumidor"
              :error-messages="errorMessagesData()"
              data-cy="input_data_nascimento"
            />

            <v-text-field
              v-model="dadosPessoais.federal_tax_number"
              v-mask="['###.###.###-##', '##.###.###/####-##']"
              background-color="white"
              label="*CPF ou CNPJ"
              filled
              maxlength="18"
              :error-messages="errorMessagesCpfCnpj"
              :disabled="isNotConsumidor"
              data-cy="input_cpf_cnpj"
              @blur="$v.dadosPessoais.federal_tax_number.$touch()"
            />

            <p class="body-2 primary--text">
              Contato
            </p>

            <v-text-field
              v-model="dadosPessoais.phone_number"
              v-mask="['(##) ####-####', '(##) #####-####']"
              background-color="white"
              label="*Telefone"
              filled
              maxlength="15"
              :error-messages="errorMessagesTelefone"
              :disabled="isNotConsumidor"
              data-cy="input_telefone"
              @blur="$v.dadosPessoais.phone_number.$touch()"
            />
          </v-form>

          <div
            :class="$vuetify.breakpoint.mdAndUp
              ? 'botoes-rodape--desktop' : 'botoes-rodape--mobile'"
            class="grey lighten-3 botoes-rodape pa-3 px-md-0 mt-md-2"
          >
            <v-btn
              :class="$vuetify.breakpoint.mdAndUp ? 'btn-desktop' : 'btn-mobile'"
              color="primary"
              data-cy="btn_voltar"
              exact
              outlined
              to="/meu-perfil"
            >
              Voltar
            </v-btn>

            <v-btn
              color="primary"
              data-cy="btn_salvar"
              :class="$vuetify.breakpoint.mdAndUp ? 'btn-desktop' : 'btn-mobile'"
              :disabled="btnDisabled"
              :loading="btnLoading"
              @click="mudarDados()"
            >
              Salvar
            </v-btn>
          </div>

          <SnackBar
            :mensage="snackBar.message"
            :snackbar="snackBar.show"
            :color="snackBar.color"
            button
            @changeSnackBar="v => snackBar.show = v.visible"
          />
        </template>
      </template>
    </InternaMain>
  </Wrapper>
</template>

<script>
import { mask } from 'vue-the-mask';
import { required } from 'vuelidate/lib/validators';
import { cpf, cnpj } from 'cpf-cnpj-validator';
import validaNomeComSobrenome from '@/utils/validacoes/validaNomeComSobrenome';
import validaDataNascimento from '@/utils/validacoes/validaDataNascimento';

import ApiMeuPerfil from '@/api/meuPerfil';
import ApiScoreConsumidor from '@/api/scoreConsumidor';
import InternaMain from '@/components/InternaMain.vue';
import Loading from '@/components/Loading.vue';
import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import TituloPagina from '@/components/TituloPagina.vue';
import ErrorServidor from '@/components/ErrorServidor.vue';
import SnackBar from '@/components/SnackBar.vue';

export default {
  name: 'DadosPessoais',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    TituloPagina,
    ErrorServidor,
    Loading,
    SnackBar,
  },

  directives: { mask },

  data() {
    return {
      tituloPagina: 'Dados pessoais',
      erro: false,
      loading: true,
      dadosPessoais: {},
      btnDisabled: true,
      btnLoading: false,
      formCarregado: 0,
      dataInput: '',
      mensagens: {
        nomeCompleto: 'Por favor, preencha o campo com o nome completo.',
        cpf: 'Por favor, digite um CPF válido.',
        cnpj: 'Por favor, digite um CNPJ válido.',
        data: 'Data inválida',
        telefoneInvalido: 'Telefone inválido',
        telefoneRequired: 'Por favor, preencha o campo telefone corretamente.',
      },
      snackBar: {
        message: 'Dados salvos com sucesso',
        color: 'success',
        show: false,
      },
    };
  },

  computed: {
    dataLayout: {
      get() {
        if (!this.dataInput) return '';
        return this.dataInput.split('-').reverse().join('/');
      },
      set(value) {
        const data = value.split('/').reverse().join('-');
        this.dataInput = data;

        if (value.length === 10) {
          const dataValida = validaDataNascimento(data);
          if (dataValida) {
            this.dadosPessoais.date_of_birth = data;
          }
        } else if (value.length === 0) {
          this.dadosPessoais.date_of_birth = value;
        }
      },
    },

    isNotConsumidor() {
      return this.dadosPessoais.user_type !== 'customer';
    },

    isCpf() {
      if (this.dadosPessoais.federal_tax_number.length < 15) return true;

      return false;
    },

    errorMessagesNome() {
      if (this.$v.dadosPessoais.name.$invalid) {
        return this.mensagens.nomeCompleto;
      }

      return [];
    },

    errorMessagesCpfCnpj() {
      const cpfCnpj = this.$v.dadosPessoais.federal_tax_number;

      if (cpfCnpj.$invalid && cpfCnpj.$dirty) {
        if (this.isCpf) return this.mensagens.cpf;

        return this.mensagens.cnpj;
      }
      return [];
    },

    errorMessagesTelefone() {
      const telefone = this.$v.dadosPessoais.phone_number;

      if (!telefone.required && telefone.$dirty) return this.mensagens.telefoneRequired;
      if (!telefone.telefoneInvalido && telefone.$dirty) return this.mensagens.telefoneInvalido;

      return [];
    },
  },

  watch: {
    dadosPessoais: {
      handler() {
        this.verificaValidacao();
      },
      deep: true,
    },

    dataInput() {
      this.verificaValidacao();
      this.errorMessagesData();
    },
  },

  validations() {
    return {
      dadosPessoais: {
        name: {
          required,
          possuiSobrenome: validaNomeComSobrenome,
        },
        federal_tax_number: {
          required,
          cpfCnpj: value => ((this.isCpf) ? cpf.isValid(value) : cnpj.isValid(value)),
        },
        phone_number: {
          required,
          telefoneInvalido: value => value.length > 13 && !value.match(/\(0{2}\) 0{4,5}-0{4}/),
        },
      },
    };
  },


  created() {
    ApiMeuPerfil.userData()
      .then((response) => {
        const objetoTrataNull = {};
        Object.entries(response.data).forEach(([key, value]) => {
          objetoTrataNull[key] = value || '';
        });
        this.dadosPessoais = objetoTrataNull;
        this.dataInput = this.dataBanco(this.dadosPessoais.date_of_birth);
      })
      .catch(() => {
        this.erro = true;
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    async scoreConsumidor() {
      await ApiScoreConsumidor.scoreConsumidor('profile_personal_data');
    },

    validaData(data) {
      const minLength = data.length === 0;
      const maxLength = data.length === 10;

      return (minLength || (maxLength && validaDataNascimento(data)));
    },

    dataBanco(data) {
      if (!data) return '';
      const novaData = new Date(data).toISOString().substr(0, 10);

      return novaData;
    },

    errorMessagesData() {
      const valido = this.validaData(this.dataInput);

      if (valido) return [];

      return this.mensagens.data;
    },

    verificaValidacao() {
      if (!this.loading) {
        if (this.formCarregado === 1) {
          const dataValido = this.validaData(this.dataInput);

          if (!this.$v.dadosPessoais.$invalid && dataValido) {
            this.btnDisabled = false;
          } else {
            this.btnDisabled = true;
          }
        } else {
          this.formCarregado += 1;
        }
      }
    },

    mudarDados() {
      const formData = {};
      const dados = this.dadosPessoais;
      const cpfCnpj = dados.federal_tax_number.replace(/[^0-9]/g, '');
      const telefone = dados.phone_number.replace(/[^0-9]/g, '');

      formData.name = dados.name;
      formData.date_of_birth = dados.date_of_birth;
      formData.federal_tax_number = cpfCnpj;
      formData.phone_number = telefone;
      this.btnLoading = true;

      ApiMeuPerfil.userDataChange(formData)
        .then(() => {
          this.snackBar.show = true;
          this.btnDisabled = true;
          this.scoreConsumidor();
        })
        .catch(() => {
          this.snackBar.message = 'Tente novamente mais tarde.';
          this.snackBar.color = 'error';
          this.snackBar.show = true;
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/scss/botoes-fixos.scss';
</style>
